import React, { Component } from 'react'
import { Modal } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SiteDropdown from '../../../Templates/SiteDropdown/SiteDropdown'
import SurveyDropdown from '../../../Templates/SurveyDropdown/SurveyDropdown'
import callAPI from '../../../../../helpers/callAPI'

class PropertySetModal extends Component {
    state = {
        setSubmitLoaded: true,
        siteId: 0,
        surveyId: 0,
        status: 'A',
        organicTrafficOnly: 'N',
        site: null,
        survey: null,
    }

    closeModal = () => {
        this.setState({
            ...this.state,
            site: null,
            survey: null,
            siteId: 0,
            surveyId: 0,
            //createPropertyModalOpen: !this.state.createPropertyModalOpen,
            }, () => {
            this.props.closeModal();
        })
    }

    updateSiteId = () => {
        console.log('Updating site:', this.state.site)
        this.setState({
            ...this.state,
            siteId: this.state.site? this.state.site.id : 0,
        })
    }

    updateSurveyId = () => {
        this.setState({
            ...this.state,
            surveyId: this.state.survey ? this.state.survey.id : 0,
        })
    }

    createSet = async () => {
        // Create the set
        console.log('Creating set...')
        this.setState({
            ...this.state,
            setSubmitLoaded: false,
        })

        const authtoken = localStorage.getItem('adm-auth-token')
        const propertyId = this.props.propertyId

        const result = await callAPI(`avatar/property/${propertyId}/propertySet`, 'POST', {
            siteId: this.state.siteId,
            surveyId: this.state.surveyId,
            status: this.state.status,
            organicTrafficOnly: this.state.organicTrafficOnly
        })
        if (result['success'] === true) {
            this.props.showSystemMessage('success', 'Property set has been added.')
            // Call a props function to push the set to AvatarProperty's state upon success.
            this.setState({
                setSubmitLoaded: true,
            })
            this.closeModal()
            this.props.refreshProperty()
        } else if (result['success'] === false) {
            this.props.showSystemMessage('error', result.errors.message)
            this.setState({
                setSubmitLoaded: true,
            })
        } else {
            this.props.showSystemMessage('error', result.errors.message)
            this.setState({
                setSubmitLoaded: true,
            })
        }
    }

    handleSiteChange = (e) => {
        this.setState({
            ...this.state,
            siteId: e.target.value,
        })
    }

    handleSurveyChange = (e) => {
        this.setState({
            ...this.state,
            surveyId: e.target.value,
        })
    }

    handleStatusChange = (e) => {
        this.setState({
            ...this.state,
            status: e.target.value,
        })
    }

    handleOrganicChange = (e) => {
        this.setState({
            ...this.state,
            organicTrafficOnly: e.target.value,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        // If the siteId changes, update the site object
        if (prevState.site !== this.state.site) {
            this.updateSiteId()
        }
        // If the surveyId changes, update the survey object
        if (prevState.survey !== this.state.survey) {
            this.updateSurveyId()
        }
    }

    render() {
        return (
            <Modal isOpen={this.props.open} toggle={this.closeModal} className="modal-md">
                <div className="modal-header">
                    <h5 className="modal-title">Add a new site/survey set</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
                <div className="modal-body">
                    <label htmlFor="site-dropdown">Choose a site:</label>
                    <SiteDropdown site={this.state.site} setSite={(site) => this.setState({ site })}  order={2}/>

                    <label htmlFor="site-dropdown" className="mt-2">
                        Choose a Survey:
                    </label>
                    <SurveyDropdown survey={this.state.survey} setSurvey={(survey) => this.setState({ survey })} order={1}/>

                    <label htmlFor="site-dropdown" className="mt-2">
                        Status:
                    </label>
                    <select className="form-control" onChange={this.handleStatusChange} required>
                        <option value="A">Active</option>
                        <option value="C">Inactive</option>
                    </select>

                    <label htmlFor="site-dropdown" className="mt-2">
                        Organic Traffic Only:
                    </label>
                    <select className="form-control" onChange={this.handleOrganicChange} required>
                        <option value="N">No</option>
                        <option value="Y">Yes</option>
                    </select>

                    {this.state.setSubmitLoaded ? (
                        <button className="btn btn-primary btn-sm mt-3" onClick={this.createSet}>
                            Create Set
                        </button>
                    ) : (
                        <button className="btn btn-secondary btn-sm mt-3" disabled>
                            <FontAwesomeIcon icon="spinner" spin />
                        </button>
                    )}
                </div>
            </Modal>
        )
    }
}

export default PropertySetModal
